module.exports = require('./lib').default;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/radium/index.js
// module id = 10
// module chunks = 168707334958949